/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var SurfaceConnectionProvider;
(function (SurfaceConnectionProvider) {
    SurfaceConnectionProvider["MICROSOFT"] = "microsoft";
    SurfaceConnectionProvider["GOOGLE"] = "google";
})(SurfaceConnectionProvider || (SurfaceConnectionProvider = {}));
